import { Dropdown } from "react-bootstrap";
import { AccountSettingsItems } from "./AccountSettingsItems";
import { WorkspaceSettingsItems } from "./WorkspaceSettingsItems";
import { ReferralModalTrigger } from "./ReferralModalTrigger";

export const MainViewUserDropdownItems: React.FC = () => (
    <>
        <AccountSettingsItems />
        <ReferralModalTrigger />

        <Dropdown.Divider />
        <WorkspaceSettingsItems />
    </>
);
